import React, { createContext, useContext, useState } from 'react';

/**
 * Where a page wants its StepBar to land. The wizard puts the slot as the last
 * child of its scrolling main column, outside the padded canvas, so the bar
 * spans the column edge to edge and sits flush on the bottom. Without a
 * provider (galleries, tests) the bar renders in place.
 */
interface SlotContextValue {
  target: HTMLElement | null;
  setTarget: (el: HTMLElement | null) => void;
}

const StepBarSlotContext = createContext<SlotContextValue | null>(null);

export const StepBarSlotProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  return <StepBarSlotContext.Provider value={{ target, setTarget }}>{children}</StepBarSlotContext.Provider>;
};

/** The render target. Sticky, so it holds the bottom while the column scrolls. */
export const StepBarSlot: React.FC = () => {
  const ctx = useContext(StepBarSlotContext);
  return <div ref={ctx?.setTarget} className="sticky bottom-0 z-30 empty:hidden" data-testid="step-bar-slot" />;
};

export const useStepBarTarget = (): HTMLElement | null => useContext(StepBarSlotContext)?.target ?? null;
